import { Component } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import * as moment from 'moment';
import { AviInvoiceForm } from 'src/app/form-template/avi-invoice-form';
import { AviInvoiceItemForm } from 'src/app/form-template/avi-invoice-item-form';
import { HttpService } from 'src/app/service/http.service';
import { DecimalValidator } from 'src/app/validator/decimal-validator';
import { ToastMessageService } from '../../toast-message.service';
import { ApiError } from 'src/app/api-error';
import { AviInvoice } from 'src/app/avi-invoice';
import { AviInvoiceItem } from 'src/app/avi-invoice-item';
import { AviInvoiceRecipient } from 'src/app/avi-invoice-recipient';
import { Country } from 'src/app/country';
import { AviInvoiceIssuer } from 'src/app/avi-invoice-issuer';

@Component({
  selector: 'app-create-avi-invoice',
  templateUrl: './create-avi-invoice.component.html',
  styleUrls: ['./create-avi-invoice.component.css']
})
export class CreateAviInvoiceComponent {

  invoiceForm: FormGroup<AviInvoiceForm> | null = null;
  invoiceNumberPrefix: string;
  avi: AviInvoiceRecipient = {
    id: 1,
    name: "AVI International",
    address1: "10 avenue de l'Arche",
    address2: "92419 Courbevoie Cedex",
    vatNumber: "FR72323234575",
    country: new Country(76, "France")
  };
  lvi: AviInvoiceIssuer = {
    id: 1,
    name: "Langues Vivantes - Interlingua",
    address1: "Rue John Waterloo Wilson 28",
    address2: "1000 Bruxelles",
    country: new Country(21, "Belgium"),
    vatNumber: "BE.0448.926.985"
  };

  month: string;
  year: string;

  constructor(
    private httpService: HttpService,
    private builder: FormBuilder,
    private toastService: ToastMessageService
  ){
    const now = moment();
    this.month = now.format("MM");
    this.year = now.format("YY");
    this.invoiceNumberPrefix = this.year + "." + this.month + ".";

    this.invoiceForm = builder.group({
      invoiceNumber: new FormControl<number | null>(null),
      itemForms: new FormArray<FormGroup<AviInvoiceItemForm>>([])
    });
  }

  get itemForms(){
    return this.invoiceForm?.get("itemForms") as FormArray;
  }

  addItemForm(){
    const itemForms = this.itemForms;
    itemForms.push(this.builder.group(
      {
        description: new FormControl<string>(""),
        amount: new FormControl<number>(0, [DecimalValidator])
      }
    ));
  }

  submitInvoiceForm(){
    if(this.invoiceForm?.value.invoiceNumber){
      const invoiceNumber = this.invoiceForm.value.invoiceNumber;
      if(!this.isInteger(invoiceNumber.toString())){
        this.toastService.addError("Error", "Invoice number should be an integer without space");
        return;
      }
      this.checkInvoiceNumber(invoiceNumber.toString());
    } else {
      this.toastService.addError("Error", "Invoice number is missing");
    }

  }

  checkInvoiceNumber(invoiceNumber: string){
    const now = moment();
    const year = now.format("yyyy");

    let result =  false;
    this.httpService.checkInvoiceNumber(Number(invoiceNumber), Number(year)).subscribe(res => {
      result = res;
      if(result === true){
        this.toastService.addError("Error", "This invoice number is taken. Use another one.");
        return;
      }
      let invoice = this.createInvoice();
      this.httpService.postAviInvoice(invoice).subscribe(() => {
        this.toastService.addSuccess("Success", "Invoice is created");
      }, error => {
        let apiError = new ApiError(error);
        this.toastService.addApiError(apiError);
      });

    }, error => {
      let apiError = new ApiError(error);
      this.toastService.addApiError(apiError);
    });
  }

  createInvoice(){
    let invoice: AviInvoice = {
      id: null,
      created: null,
      date: moment(), 
      lineItems: [],
      recipient: this.avi,
      issuer: this.lvi,
      invoiceNumberStr: "",
      invoiceNumber: {
        month: Number(this.month),
        year: Number(this.year),
        number: Number(this.invoiceForm!.controls.invoiceNumber.value!)
      }
    };

    let itemForms = this.itemForms;
    for(let form of itemForms.controls){
      let item: AviInvoiceItem = {
        description: form.value.description,
        amount: form.value.amount
      };
      invoice.lineItems.push(item);
    }

    return invoice;
  }

  isInteger(str: string){
    return /^\d+$/.test(str);
  }
}
